import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, first } from 'rxjs';

import { SubscriptionsService } from '../process/subscriptions/subscriptions.service';
import { ATOService } from '../process/ato/ato.service';
import { ValuesService } from '../../values/values.service';
import { NavigationService } from '../../navigation/navigation.service';
import { SetupStep } from '../../models/ato/AtoGeneral.model';


@Injectable({ providedIn: 'root' })

export class ATOGuard {

    constructor(
        private readonly atoService:            ATOService,
        private readonly navigationService:     NavigationService,
        private readonly router:                Router,
        private readonly subscriptionsService:  SubscriptionsService,
        private readonly valuesService:         ValuesService
    ) { }

    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return new Observable(subscriber => {
            const hasATO = this.subscriptionsService.hasATO();
            if (!hasATO) {
                subscriber.next(false);
                subscriber.complete();
                return;
            }

            const urlProperties = this.navigationService.processUrl(_route, _state);
            const path = urlProperties.entirePath;
            const setupPath = this.valuesService.centralPaths.ato.path.concat(this.valuesService.centralPaths.ato.setup.path);
            const activityPath = this.valuesService.centralPaths.ato.path.concat(this.valuesService.centralPaths.ato.activity.path);

            this.atoService.checkIdentityStatus()
            .pipe(first())
            .subscribe({
                next: () => {
                    if (this.subscriptionsService.hasATOExpired() || this.atoService.getSubsIsExpired() || this.atoService.checkIfSubsIsExpiredAfterCalls()) {
                        if (path.indexOf(activityPath) === -1) {
                            subscriber.next(this.router.parseUrl(`/${activityPath}`));
                        } else {
                            subscriber.next(true);
                        }
                        subscriber.complete();
                        return;
                    }

                    const onBoardingIsInProgress = this.atoService.atoIdentityOnboardingInProgress();
                    if (onBoardingIsInProgress && path.indexOf(setupPath) !== 0) {
                        subscriber.next(this.router.parseUrl(`/${setupPath}`));
                        subscriber.complete();
                        return;
                    } else if (!onBoardingIsInProgress && path.indexOf(setupPath) === 0) {
                        subscriber.next(this.router.parseUrl(`/${activityPath}`));
                        subscriber.complete();
                        return;
                    }
                    subscriber.next(true);
                    subscriber.complete();
                },
                error: () => {
                    subscriber.next(true);
                    subscriber.complete();
                }
            });
        });

    }

}
